import React, { useContext, useState }                from 'react'
import { X }                                from 'react-feather'
import { ChatContext }                      from '..'
import { ChatWsContext }                    from '..'
import { Button, InputGroup, Input }        from 'reactstrap'
import { CardGroupMember }                  from '../card/CardGroupMember'


const SidebarGroupInformation = (props) => {

    // CONTEXT
    const {
        visibilityGroupInformation,
        changeVisibilityGroupInformation,
        setVisibilityModalAddMemberGroup,
    } = useContext(ChatContext)

    const {
        activeRoom,
        detailActiveRoom,
        memberGroup,
    } = useContext(ChatWsContext)

    const [keyword, setKeyword] = useState("")

    const renderAllMember = () => {
        return (
            memberGroup !== null ? (
                memberGroup.map((item) => {
                    return (
                        <CardGroupMember
                            key={item.uuid} member={item} isAdmin={item.isAdmin} meAsAdmin={item.meAsAdmin} isMe={item.isMe} idRoom={item.idRoom}
                        />
                    )
                })
            ) : null
        )
    }

    const handleSearchMember = () => {
        let newList = memberGroup.filter((item) => item.name.toLowerCase().startsWith(keyword.toLocaleLowerCase()))

        return(
            newList !== null ? (
                newList.map((item) => {
                    return (
                        <CardGroupMember
                            key={item.uuid} member={item} isAdmin={item.isAdmin} meAsAdmin={item.meAsAdmin} isMe={item.isMe} idRoom={item.idRoom}
                        />
                    )
                })
            ) : null
        )
    }

    return (
        <>
            {
                activeRoom !== null ? (
                    <div className={`sidebar-left bg-white p-0 shadow-sm col-lg-auto ${visibilityGroupInformation}`}
                        style={{ width: '380px' }}>
                        <div className='sidebar'>
                            <div className='border-bottom d-flex justify-content-between px-2 mb-0 ' style={{ height: '110px' }}>
                                <div className='sidebar-toggle me-1 align-self-center'>
                                    <X size={21} className='cursor-pointer mr-1' onClick={() => changeVisibilityGroupInformation(false)} />
                                    <strong className='text-uppercase text-primary'>
                                        Informasi Grup
                                    </strong>
                                </div>
                            </div>

                            <div className="pl-2 pr-2 pt-2 pb-0">
                                <strong>
                                    {
                                        detailActiveRoom !== null ? (
                                            detailActiveRoom.member.length
                                        ) : null
                                    } Anggota Grup
                                </strong>
                            </div>

                            <div className='align-items-center pt-1 px-2 pb-1' >
                                <InputGroup className='input-group-merge w-100 mb-1'>
                                    <Input placeholder='Cari Anggota...'
                                        onChange={(event) => setKeyword(event.target.value)}
                                    />
                                </InputGroup>

                                <Button color="primary" className="col-12" onClick={() => setVisibilityModalAddMemberGroup(true)}>
                                    Tambah Anggota
                                </Button>
                            </div>

                            <div className="pt-0 pb-2 m-0" style={{ overflow: 'scroll', height: '65%' }}>
                                <ul className='chat-users-list contact-list media-list m-0 list-group list-group-flush rounded-0' >
                                    {
                                        keyword === "" ? (
                                            renderAllMember()
                                        ) : (
                                            handleSearchMember()
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : null
            }
        </>
    )
}

export default SidebarGroupInformation;